module.exports = __webpack_public_path__ + "img/card-disabled.ed8abc96.svg";